import { FixedWhereabouts, UNKNOWN_OPTION, WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import Colours from '@shared/ui/atoms/Colours';

const colorList = [
  '#5653D2',
  '#88A7F5',
  '#4471E5',
  '#0ADCFE',
  '#C0D1FA',
  '#947AC9',
  '#7C43A9',
  '#1C2684',
]

export function whereaboutsToColour(list: WhereaboutsOption[], key: string): string {
  const idx = list.findIndex(wo => wo.key === key);
  if (key === UNKNOWN_OPTION.key) {
    return '#1EE1FF';
  } else if (key === FixedWhereabouts.Office) {
    return '#67E280'
  } else if (key === FixedWhereabouts.NotWorking) {
    return '#BCC6C7'
  } else if (key === FixedWhereabouts.HolidayPending || key === FixedWhereabouts.HolidayApproved || key === FixedWhereabouts.Holiday) {
    return '#FFD027'
  } else if (key === FixedWhereabouts.Home) {
    return '#1AA85C'
  }

  if (idx < 0) {
    return Colours.black;
  } else if (idx < colorList.length) {
    return colorList[idx];
  } else {
    return generatedColour(idx);
  }
}

// Golden-angle hue spacing keeps colours visually distinct for any number of options,
// while staying deterministic for a given position in the list. Saturation/lightness are
// kept away from the fixed office-green and holiday-yellow shades to avoid near-matches.
function generatedColour(idx: number): string {
  const hue = Math.round((idx * 137.508) % 360);
  return `hsl(${hue}, 65%, 42%)`;
}

export function hexToRGBA(hex: string, alpha: number): string {
  const h = "0123456789ABCDEF";
  const r = h.indexOf(hex[1])*16+h.indexOf(hex[2]);
  const g = h.indexOf(hex[3])*16+h.indexOf(hex[4]);
  const b = h.indexOf(hex[5])*16+h.indexOf(hex[6]);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
